module.exports = __webpack_public_path__ + "img/banner01.7cefa344.webp";